import { render } from "./FollowUsSection.vue?vue&type=template&id=e0993d1e"
import script from "./FollowUsSection.vue?vue&type=script&lang=js"
export * from "./FollowUsSection.vue?vue&type=script&lang=js"

import "./FollowUsSection.vue?vue&type=style&index=0&id=e0993d1e&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__